<template>
    <div class="page">
        <ion-grid class>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="rectangle">
                <ion-col>
                    <ion-row>
                        <!-- <ion-col size="12" size-md="4" class="col-padding">
                            <ion-label class="border-text" position="stacked">
                                Old Password
                                <span class="required">*</span>
                            </ion-label>
                            <div class="border-line">
                                <ion-input
                                class="form-input"
                                type="password"
                                placeholder="Enter old password"
                                @input="oldpassword = $event.target.value"
                                maxLength="50"
                                ></ion-input>
                            </div>
                        </ion-col> -->
                        <ion-col size="12" size-md="4" class="col-padding">
                            <ion-label class="border-text" position="stacked">
                                New Password
                                <span class="required">*</span>
                            </ion-label>
                            <div class="border-line">
                                <ion-input
                                class="form-input"
                                type="password"
                                id="newPassword"
                                placeholder="Min 8 Chars,1 Uppercase, 1 Spl Char"
                                @input="newpassword = $event.target.value"
                                maxLength="50"
                                ></ion-input>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="4" class="col-padding">
                            <ion-label class="border-text" position="stacked">
                                Confirm Password
                                <span class="required">*</span>
                            </ion-label>
                            <div class="border-line">
                                <ion-input
                                class="form-input"
                                type="password"
                                id="confPassword"
                                placeholder="Min 8 Chars,1 Uppercase, 1 Spl Char"
                                @input="confirmpassword = $event.target.value"
                                maxLength="50"
                                ></ion-input>
                            </div>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size="12" size-md="4" text-right>
                    <ion-button class="btn-primary" expand="block" @click="resetPassword">Submit</ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
</template>

<script>
import { AuthenticationService } from "../../service/account/authenticator.service";
import { IonGrid, IonRow, IonCol, IonLabel, IonInput, IonButton } from "@ionic/vue";
import { LocalStorage } from "../../data/localstorage";
import { User } from "../../entity/authentication/user";

import { ValidationUtils } from "../../util/validation-utils";

import { ToastUtils } from "../../util/toast-utils";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";

import { defineComponent } from "vue"

export default defineComponent ({
    name: 'resetPassword',
    components: {
        IonGrid, IonRow, IonCol, IonLabel, IonInput, IonButton
    },
    data() {
        return {
            oldpassword: "",
            newpassword: "",
            confirmpassword: ""
        }
    },
    methods: {
        async resetPassword() {
            try {
                // if (
                // typeof this.oldpassword === "undefined" ||
                // this.oldpassword === null ||
                // this.oldpassword === ""
                // ) {
                // alert("Enter Old password");
                // } else 
                if (
                typeof this.newpassword === "undefined" ||
                this.newpassword === null ||
                this.newpassword === ""
                ) {
                    new ToastUtils().presentToast("Enter New password");
                    document.getElementById("newPassword").setFocus();
                } else if(new ValidationUtils().password(this.newpassword) === false) {
                    new ToastUtils().presentToast("Password must be 8 characters with atleast 1 Upper Case and 1 Special Character");
                    document.getElementById("newPassword").setFocus();
                }
                else if (
                typeof this.confirmpassword === "undefined" ||
                this.confirmpassword === null ||
                this.confirmpassword === ""
                ) {
                    new ToastUtils().presentToast("Enter Confirm password");
                    document.getElementById("confPassword").setFocus();
                } else if (this.newpassword !== this.confirmpassword) {
                    new ToastUtils().presentToast("Password mismatch");
                } else {
                    let user = new LocalStorage().user;
                    await new AuthenticationService().resetPasswordForAdminUserWithoutOTP(this.newpassword, user)
                    new ToastUtils().presentToast("Password updated successfully");
                    this.$router.back();
                }
            } catch (error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        }
    }
})
</script>